import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlphapetResult, AuthSeeAlso, AuthSymbol, SearchParameter } from '../models/walai';
import { ApiConfig, ConfigService } from './config.service';


@Injectable({
  providedIn: 'root'
})
export class SearchService {
  //private baseUrl = '';
  private _apiconfig: ApiConfig;
  private apiUrl = '';
  private token = '';
  header = new HttpHeaders();

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this._apiconfig =  this.configService.apiConfig;
    this.apiUrl = this._apiconfig.url;
    this.token = this._apiconfig.token;
    this.header.append('Content-Type', 'application/json'); 
  }

  
  keywordsearch(val: any) {
    return this.http.post<any>(`${this.apiUrl}/api/BookKeywordSearch`, val, { headers: this.header });
  }

  autoSuggest(val: any, num: number) {
    return this.http.post<any>(`${this.apiUrl}/api/autosuggest/${num}`, val, { headers: this.header });
  }

  alphabetSearch(val: SearchParameter): Observable<AlphapetResult>{
    return this.http.post<any>(`${this.apiUrl}/api/AlphabeticSearch`, val, { headers: this.header });
  }


  AuthSeeAlso(val: any) {
    return this.http.post<AuthSeeAlso[]>(`${this.apiUrl}/api/CheckSeeAlso`, val, { headers: this.header });
  }

  AuthSymbol(authid: string,Type:string) {
    return this.http.post<AuthSymbol[]>(`${this.apiUrl}/api/GetAuthSymbol/${authid}/${Type}`, { headers: this.header });
  }

  addDownloadHistory(val: any) {
    return this.http.post<any>(`${this.apiUrl}/api/DownloadHistory`, val, { headers: this.header });

  }

  keywordSuggester(val: any) {
    return this.http.post<any>(`${this.apiUrl}/api/suggester`, val, { headers: this.header });
  }

}
